module.exports = __webpack_public_path__ + "static/vekt-logo-social-54b779770a3406295baffc212a9448ff.png";